<table class="page-print">
    <thead class="header-print">
        <tr>
            <th id="th-logo" scope="col">
                <img src="assets/img/logo_brasao_ES.png" alt="Brasão ES" class="brand-image" />
            </th>
            <th id="th-title" scope="col">
                <div class="title">
                    <h3><strong>Governo do Estado do Espírito Santo</strong></h3>
                    <h5>Secretaria de Estado de Controle e Transparência</h5>
                </div>
            </th>
        </tr>
    </thead>

    <tbody>
        <tr>
            <td colspan="2">
                <div class="content-print">
                    <ng-content></ng-content>
                </div>
            </td>
        </tr>
    </tbody>

    <!-- 🔥 RODAPÉ CORRETO -->
    <tfoot class="footer-print-2">
        <tr>
            <td colspan="2">
                <div>Av. João Batista Parra, nº. 600, Ed. Aureliano Hoffman, 10º andar, Enseada do Suá, Vitória /ES -
                    Cep: 29050-375</div>
                <div>Tel: (27) 3636-5352</div>
                <div class="footer-row">
                    <b>www.secont.es.gov.br</b>
                    <span class="footer-dinamico"></span>
                </div>
            </td>
        </tr>
    </tfoot>
</table>

<div class="barra-botoes no-print" *ngIf="habilitado">
    <div class="barra-botoes-interno justify-content-center">
        <div class="row">
            <div class="col-md-12">
                <button type="button" (click)="onImprimirClick()" class="btn btn-primary btn-sm mr-1 no-print">
                    <i class="fas fa-print"></i> Imprimir
                </button>
                <button type="button" (click)="onFecharClick()" class="btn btn-default btn-sm no-print">
                    <i class="fas fa-times"></i> Fechar
                </button>
            </div>
        </div>
    </div>
</div>